import { render, staticRenderFns } from "./Tutors.vue?vue&type=template&id=727a28b1&scoped=true&"
import script from "./Tutors.vue?vue&type=script&lang=js&"
export * from "./Tutors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727a28b1",
  null
  
)

export default component.exports